<template>
  <chart :chartData="chartData" :options="options" style="height: 25vh; width: 100%; min-height: 250px" />
</template>

<script>
import chart from "./chart";
export default {
  components: { chart },
  props: ["chartData", "options"]
};
</script>
